// @lib-export
var UrlParamVo;
(function (UrlParamVo) {
    UrlParamVo["APP_ID"] = "appId";
    UrlParamVo["APP_NAME"] = "appName";
    UrlParamVo["ARTICLE_NAME"] = "articleName";
    UrlParamVo["BOT"] = "bot";
    UrlParamVo["DESK"] = "desk";
    UrlParamVo["ENV"] = "env";
    UrlParamVo["FORM_DETAILS"] = "formDetails";
    UrlParamVo["FORM_NAME"] = "formName";
    UrlParamVo["ID"] = "id";
    UrlParamVo["LNG"] = "lng";
    UrlParamVo["QUERY"] = "query";
    UrlParamVo["URI"] = "uri";
    UrlParamVo["WORK_ITEM_APP_ID"] = "workItemAppId";
    UrlParamVo["WORK_ITEM_ID"] = "workItemId";
})(UrlParamVo || (UrlParamVo = {}));

export { UrlParamVo };
//# sourceMappingURL=url-param-vo.js.map
